var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "mb-3" }, [
        _c("label", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "revobase.localization.model.localeStringResource.resourceName"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.translation.resourceName,
              expression: "translation.resourceName"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "text", disabled: !_vm.isNew },
          domProps: { value: _vm.translation.resourceName },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.translation, "resourceName", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm._l(_vm.store.locales, function(locale) {
        return _c("TranslationEditorLocale", {
          key: locale,
          attrs: {
            translation: _vm.translation,
            locale: locale,
            editInherited: _vm.editInherited
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }